import React from 'react';
import { connect } from 'react-redux';
import { createPortal } from 'react-dom';
import Panel from '@/components/Panel';
import Table from '@/components/EditableTable';
import MsgDialogPanel from '@/components/MsgDialog/msgPanel';
import ICModelPanel from '@/components/ICModelPanel';
import { Button, Divider, Input, Progress, Select, Switch, Tabs, Tooltip } from 'antd';
import { CloseOutlined, EyeOutlined, FileTextOutlined, InfoCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { getSearchVictimAggressorLog, getSearchVictimAggressorStatus, getVictimAggressor, getVictimContent, searchVictimAggressor, updateVictimAggressor } from '@/services/Sierra/SierraCtrl';
import { numberCheck } from '@/services/helper/dataProcess';
import { IBIS, SPICE } from '@/constants/libraryConstants';
import sierraLibrary from "@/services/Sierra/library/libraryStorage";
import { getFilterIdentificationLog } from '@/services/Sierra/helper/interfaceCreationHelper';
import { generateVictimContentParams, getAggressorSignalNets, getVictimICComp, getSelectCanvasData, getAllAggressorSignalNets } from '../../../../../../services/Sierra/helper/victimAggressorSearchHelper';
import { SIERRA } from '@/constants/pageType';
import { getIbisModelList, getSpiceModelList } from '@/services/Sierra/library';
import { getPins } from '@/services/Sierra/library/IbisModelHelper';
import designConstructor from '@/services/helper/designConstructor';
import { saveVictimContent, updateOptions } from '../../../../store/sierra/action';
import { cancelTask } from '@/services/CCC';
import './index.css';
import { getSelectedDesignIDs } from '../../../../../../services/helper/dataProcess';
import { changeDisplaySelected, changeShowNameStatus, selectChange, selectLayer } from '../../../../../LayoutExplorer/store/Sierra/actionCreators';

const NOT_START = "not_start", RUNNING = "running", SUCCESS = "success", FAILED = "failed", CANCEL = "cancel", LOADING = "loading";
const toolTipContent = (
  <div>
    <h4>For trace:</h4>
    <p>Search for victim nets whose distance to the aggressor trace is less than N times the aggressor trace's width.</p>
    <h4>For via:</h4>
    <p>Search for victim net whose distance to the aggressor via is less than N times the aggressor via's barrel diameter.</p>
  </div>
)

const compModel = (victimICComp) => victimICComp && victimICComp.pinModelsInfo && victimICComp.pinModelsInfo.model ? victimICComp.pinModelsInfo.model || {} : {}

class VictimAggressorSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // input / select
      searchDistance: 5,
      inputValue: undefined,
      inputError: '',
      selectPCBs: [],
      selectPCBsStatus: undefined,
      progress: 0,
      // search setup
      searchStatus: LOADING,
      searchData: [],
      deleteVictims: [],
      // model file
      ibisList: [],
      spiceList: [],
      modelVisible: false,
      victimICComp: {},
      // tabs
      activePcb: '',
      // log
      logs: [],
      logVisible: false,
      logPcbName: "",
      taskId: "",
      // vitim content
      victimContent: []
    }

    this.dialogRoot = document.getElementById('root');
    this.searchTimer = null;
    this.signalNetsColumns = [];
    // Record the selected buffer model data and use it when generating victim content
    this.bufferModelParams = [];
    // Make sure that abnormal closures can be saved
    this.save = false;
  }

  async componentDidMount() {
    const isStop = await this.getSearchStatus();
    if (!isStop) {
      this.searchTimer = setInterval(() => {
        this.getSearchStatus();
      }, 1000);
    }
    const { currentPCBs } = this.props;
    this.setState({
      ibisList: [...sierraLibrary.getTree(IBIS)],
      spiceList: [...sierraLibrary.getTree(SPICE)],
      selectPCBs: currentPCBs.map(it => it.isPreLayout ? null : it.pcbId).filter(item => !!item)
    })
    this.signalNetsColumns = [
      {
        title: () => {
          const iconDisplay = this.getIconDisplay("victimNets");
          return <div className='search-setup-title'>
            Victim Signal Nets
            {iconDisplay ? <EyeOutlined
              className="aurora-select-nets-icon"
              title={'Display all signal nets to layout.'}
              onClick={() => this.victimNetsSelect(true)} />
              : null}
          </div>
        },
        dataIndex: "signalNets",
        key: "signalNets",
        render: (_, record) => {
          const iconDisplay = this.getIconDisplay("victimNets");
          const { signalNets = [], victimAggressors = [] } = record;
          const victimNets = victimAggressors.map(it => it.victimNet).filter(it => signalNets.includes(it));
          const otherNets = signalNets.filter(it => !victimNets.includes(it));
          return (
            <div className={iconDisplay ? "nets-content" : ""} onClick={() => iconDisplay ? this.clickRowNets(record) : null}>
              <span className="victim-net">{victimNets.join(", ")}</span>
              <span>{otherNets.length ? ", " : ""}{otherNets.join(", ")}</span>
            </div>
          )
        }
      },
      {
        title: () => {
          const iconDisplay = this.getIconDisplay("aggressorNets");
          return <div className='search-setup-title'>
            Aggressor Signal Nets
            {iconDisplay ? <EyeOutlined
              className="aurora-select-nets-icon"
              title={'Display all signal nets to layout.'}
              onClick={() => this.aggressorNetsSelect(true)} />
              : null}
          </div>
        },
        dataIndex: "victimAggressors",
        key: "victimAggressors",
        render: (_, record) => {
          const signalNetsObj = getAggressorSignalNets(record.victimAggressors);
          const iconDisplay = this.getIconDisplay("aggressorNets");
          return (
            <div className={iconDisplay ? "nets-content" : ""} onClick={() => iconDisplay ? this.clickRowNets(record) : null}>
              {Object.keys(signalNetsObj).map((signal) => (
                <div key={`${signal}-${signalNetsObj[signal][0]}`}>
                  <span className='victim-net'>{signal}</span>
                  <span> ({signalNetsObj[signal].join(", ")}) </span>
                </div>
              ))}
              <CloseOutlined className='icon-delete' onClick={(e) => this.deleteSignalNets(e, record)} />
            </div>
          )
        }
      },
    ]
  }

  componentDidUpdate(prevProps) {
    const { libraryTreeInfo } = this.props;
    const judgeLibraryTreeInfo = (type) => ((libraryTreeInfo || []).includes(type) && !(prevProps.libraryTreeInfo || []).includes(type));
    if (judgeLibraryTreeInfo(IBIS)) {
      this.setState({ ibisList: [...sierraLibrary.getTree(IBIS)] });
    }

    if (judgeLibraryTreeInfo(SPICE)) {
      this.setState({ spiceList: [...sierraLibrary.getTree(SPICE)] });
    }

    if (prevProps.currentPCBs.length !== this.props.currentPCBs.length) {
      const { currentPCBs } = this.props;
      this.setState({ selectPCBs: currentPCBs.map(it => it.isPreLayout ? null : it.pcbId).filter(item => !!item) });
    }
  }

  componentWillUnmount() {
    this.searchTimer && clearInterval(this.searchTimer);
    if (this.save) {
      this.closeModal();
    }
  }

  getIconDisplay = (type) => {
    const { selectedDesignIDs } = this.props;
    const { activePcb } = this.state;
    const iconDisplay = selectedDesignIDs.includes(activePcb) > 0 ? true : false;

    if (type === "aggressorNets" && iconDisplay) {
      const { Interfaces } = this.props;
      const interfaceExist = Interfaces.find(item => item.pcbId === activePcb);
      return interfaceExist && iconDisplay;
    }

    return iconDisplay;
  }

  victimNetsSelect = async (isAll, nets, isReturn) => {
    const { activePcb: pcbId, victimContent } = this.state;
    if (!victimContent || !victimContent.length) {
      await this.getVictimContent();
    }

    const pcbContent = victimContent.find(it => it.pcbId === pcbId);
    if (!pcbContent || !pcbContent.content || !pcbContent.content.signals || !pcbContent.content.signals.length) {
      return {
        pinsObj: {},
        comps: [],
        layers: []
      };
    }
    let signalNets = [];
    if (isAll) {
      for (let signal of pcbContent.content.signals) {
        signalNets.push(...signal.nets);
      }
    } else {
      signalNets = [...nets];
    }
    const { pinsObj, comps, layers } = getSelectCanvasData({ pcbId, signalNets, content: pcbContent.content })
    if (isReturn) {
      return { pinsObj, comps, layers };
    }
    this.viewLayout(pcbId, signalNets, pinsObj, comps, layers);
  }

  aggressorNetsSelect = (isAll, nets, isReturn) => {
    const { Interfaces } = this.props;
    const { activePcb: pcbId, searchData } = this.state;
    const pcbContent = Interfaces.find(item => item.pcbId === pcbId);
    if (!pcbContent || !pcbContent.content || !pcbContent.content.signals || !pcbContent.content.signals.length) {
      return {
        pinsObj: {},
        comps: [],
        layers: []
      };
    }
    let signalNets = [];
    if (isAll) {
      const data = searchData.find(it => it.pcbId === pcbId) || {};
      const victims = data.victims || [];
      signalNets = getAllAggressorSignalNets(victims || []);
    } else {
      signalNets = [...nets];
    }
    const { pinsObj, comps, layers } = getSelectCanvasData({ pcbId, signalNets, content: pcbContent.content })
    if (isReturn) {
      return { pinsObj, comps, layers };
    }
    this.viewLayout(pcbId, signalNets, pinsObj, comps, layers);
  }

  clickRowNets = async (record) => {
    const { activePcb: pcbId } = this.state;
    const { signalNets = [], victimAggressors = [] } = record;
    // victim
    const victimNets = victimAggressors.map(it => it.victimNet).filter(it => signalNets.includes(it));
    const otherNets = signalNets.filter(it => !victimNets.includes(it));
    const selectData1 = await this.victimNetsSelect(false, [...victimNets, ...otherNets], true);
    // aggessors
    const aggressorNets = victimAggressors.map(item => item.aggressorNets).flat();
    const nets = [...new Set(aggressorNets.map(({ net }) => net))];
    const selectData2 = this.aggressorNetsSelect(false, nets, true);

    let pinObj = {};
    for (const comp of Object.keys({ ...selectData1.pinsObj, ...selectData2.pinsObj })) {
      pinObj[comp] = [...new Set([...(selectData1.pinsObj[comp] || []), ...(selectData2.pinsObj[comp] || [])])];
    }
    const comps = [...new Set([...selectData1.comps, ...selectData2.comps])];
    const layers = [...new Set([...selectData1.layers, ...selectData2.layers])];
    this.viewLayout(pcbId, [...victimNets, ...otherNets, ...nets], pinObj, comps, layers);
  }

  viewLayout = (pcbId, signalNets, pinsObj, comps, layers) => {
    this.props._selectLayer(layers, pcbId);
    this.props._selectChange({ pinsObj, comps, nets: [...signalNets] }, pcbId);
    this.props.changeDisplaySelected(true, pcbId)
    this.props._changeShowNameStatus(true, pcbId)
  }

  clickSearch = (searchMode) => {
    const { verificationId } = this.props;
    const { searchDistance, selectPCBs, inputError } = this.state;
    if (inputError) {
      return;
    }
    if (!selectPCBs.length) {
      this.setState({ selectPCBsStatus: 'warning' });
      return;
    }
    searchVictimAggressor(verificationId, Number(searchDistance), selectPCBs, searchMode).then(() => {
      this.setState({ searchStatus: RUNNING, progress: 0, logs: [], taskId: "", victimContent: [] }, async () => {
        const isStop = await this.getSearchStatus("clickSearch");
        if (!isStop) {
          this.searchTimer = setInterval(() => {
            this.getSearchStatus("clickSearch");
          }, 1000);
        }
      });
    }).catch((error) => {
      console.error('search error', error);
    })
  }

  getSearchStatus = async (getType) => {
    const { verificationId } = this.props;
    try {
      const data = await getSearchVictimAggressorStatus(verificationId);
      const { status, logs, progress, taskId } = data || {};
      this.setState({ logs, taskId, progress: progress || 0, searchStatus: status || NOT_START });
      if (status === FAILED || status === SUCCESS || status === CANCEL || !data) {
        if (status === SUCCESS) {
          this.getSearchResult(getType);
        }

        this.searchTimer && clearInterval(this.searchTimer);
        return true;
      }
    } catch (error) {
      console.error('getSearchStatus error', error);
      this.searchTimer && clearInterval(this.searchTimer);
      return true;
    }
  }

  getSearchResult = async (getType) => {
    const { verificationId } = this.props;
    const searchData = await getVictimAggressor(verificationId)

    if (!searchData) {
      this.save = false;
      // this.setState({ searchStatus: NOT_START });
      return;
    }

    this.setState({ searchData, activePcb: (searchData[0] || {}).pcbId, searchDistance: (searchData[0] || {}).searchMultiplier || 5 }, async () => {
      await this.getVictimContent(getType);
    });
  }

  getVictimContent = async (getType) => {
    const { verificationId } = this.props;
    const { searchData } = this.state;
    // get victim model info
    const victimContent = await getVictimContent(verificationId)
    if ((searchData.length && (!victimContent || !victimContent.length)) || getType === "clickSearch") {
      this.save = true;
      this.closeModal(true);
    }
    const victimICComp = getVictimICComp(victimContent);
    const model = compModel(victimICComp)
    this.bufferModelParams = {
      // prevModel: compModel(victimICComp),
      ...victimICComp,
      libType: model.libType,
      model
    }
    this.setState({ victimICComp, victimContent });
  }

  saveSearchDistance = (e) => {
    const { inputValue } = this.state;
    const error = numberCheck(inputValue, true);
    if (error) {
      e && e.target && e.target.focus && e.target.focus();
      this.setState({ inputError: error, inputValue });
      return;
    }

    this.setState({ searchDistance: inputValue, inputError: '', inputValue: undefined });
  }

  openLog = () => {
    const { verificationId, currentPCBs } = this.props;
    const { activePcb } = this.state;
    getSearchVictimAggressorLog(verificationId, activePcb).then((data) => {
      this.setState({ logs: data, logVisible: true, logPcbName: (currentPCBs.find((pcb) => pcb.pcbId === activePcb) || {}).pcbName });
    })
  }

  deleteSignalNets = (e, record) => {
    e.stopPropagation();
    const { searchData, activePcb } = this.state;
    const { index } = record;
    let pcbDataIndex = -1;

    const newSearchData = [...searchData];
    pcbDataIndex = newSearchData.findIndex((item) => item.pcbId === activePcb);
    newSearchData[pcbDataIndex].victims.splice(index, 1);
    this.setState({ searchData: newSearchData }, () => {
      this.save = true;
      this.closeModal(true);
    });
    // save data to server
    if (pcbDataIndex === -1) return;
    const { verificationId } = this.props;
    updateVictimAggressor(verificationId, newSearchData[pcbDataIndex])
  }

  closeModal = (notClose) => {
    if (this.save) {
      const { verificationId, interfaceName, interfaceType, signalNames } = this.props;
      const { searchData } = this.state;
      const res = generateVictimContentParams(searchData, interfaceName, interfaceType, signalNames);
      this.props._saveVictimContent(res, verificationId, this.bufferModelParams);
    }
    this.save = false;
    if (notClose) return;
    this.props.closeModal();
  }

  assignModel = ({ record, model, deviceVcc, pinModelsInfo }) => {
    const { victimICComp } = this.state;
    this.bufferModelParams = {
      // prevModel: compModel(victimICComp),
      model,
      libType: record.libType,
      deviceVcc,
      pinModelsInfo
    }

    this.save = true;
    this.setState({ modelVisible: false, victimICComp: { pinModelsInfo: { ...(victimICComp.pinModelsInfo || {}), model }, model } })
  }

  onCancel = () => {
    const { taskId } = this.state;
    if (!taskId) return;
    cancelTask(taskId)
  }

  searchRender = () => {
    const { currentPCBs } = this.props;
    const { searchStatus, searchDistance, inputError, inputValue, logs, selectPCBsStatus, progress, selectPCBs, taskId } = this.state;

    return <>
      <div className='search-distance-div-box'>
        <span>
          Distance
          <Tooltip title={toolTipContent} classNames={{ root: "aurora-tooltip" }}>
            <InfoCircleOutlined />
          </Tooltip>
        </span>
        <Tooltip title={inputError} classNames={{ root: "aurora-tooltip aurora-tooltip-error" }} open={inputError}>
          <Input
            value={typeof inputValue !== 'undefined' ? inputValue : searchDistance}
            onFocus={() => this.setState({ inputValue: searchDistance })}
            onChange={(e) => this.setState({ inputValue: e.target.value })}
            onBlur={(e) => this.saveSearchDistance(e)}
            addonAfter="× trace width"
          />
        </Tooltip>
      </div>
      <div className='search-distance-div-box'>
        <span>PCB(s)</span>
        <Select
          mode='multiple'
          allowClear
          status={selectPCBsStatus}
          placeholder={selectPCBsStatus ? "Please select PCB" : ""}
          value={selectPCBs}
          options={currentPCBs.map((item) => ({ value: item.pcbId, label: item.pcbName, disabled: item.isPreLayout, title: item.isPreLayout ? "Not support" : "" }))}
          onChange={(values) => this.setState({ selectPCBs: [...values], selectPCBsStatus: undefined })}
        />
      </div>
      <Button
        type="primary"
        onClick={() => this.clickSearch("global")}
        icon={<SearchOutlined />}
        disabled={!selectPCBs.length || [LOADING, RUNNING].includes(searchStatus)}
      >Search</Button>
      {/* log */}
      {[RUNNING, FAILED].includes(searchStatus) ? <>
        <div className='aurora-msg-dialog-content sierra-victim-aggressor-search-log'>
          {logs.map((item, index) => (
            <div key={index} className='aurora-msg-dialog-info-item'>
              <span>{item}</span>
            </div>
          ))}
        </div>
      </> : null}
      {searchStatus === RUNNING ? <div className='search-progress-box'>
        <Progress percent={progress} />
        {taskId ? <Tooltip title="Cancel">
          <CloseOutlined onClick={this.onCancel} />
        </Tooltip> : null}
      </div> : null}
    </>
  }

  searchResultRender = () => {
    const { currentPCBs } = this.props;
    const { activePcb, searchData, modelVisible, victimICComp } = this.state;
    const data = searchData.find((item) => item.pcbId === activePcb) || {};
    const tableData = data.victims || [];
    const model = compModel(victimICComp);
    return <>
      <Tabs
        onChange={(activeKey) => this.setState({ activePcb: activeKey })}
        activeKey={activePcb}
        items={searchData.map((item) => ({ key: item.pcbId, label: (currentPCBs.find((pcb) => pcb.pcbId === item.pcbId) || {}).pcbName }))}
      />

      <div className='search-setup-title'>
        <span>Signal Nets</span>
        <span className='distance-text'>(Distance: {data.searchMultiplier || ""} × trace width)</span>
        <Tooltip title="Search log">
          <FileTextOutlined onClick={this.openLog} />
        </Tooltip>
      </div>
      <div className='search-setup-main-item'>
        <Table
          rowKey={(record) => `${record.victimAggressors[0].victimNet} ${record.index}`}
          dataSource={tableData.map((item, index) => ({ ...item, index }))}
          columns={this.signalNetsColumns}
          scroll={tableData.length > 11 ? { y: 486 } : {}}
          tablePadding={true}
          // rowSelection={rowSelection}
          className="sierra-victim-aggressor-search-table"
        />
      </div>

      <div className='search-setup-title'>Model Setting</div>
      <div className='search-setup-main-item'>
        <div className='search-distance-div-box'>
          <span>Buffer Model</span>
          <Input disabled={modelVisible} onFocus={() => this.setState({ modelVisible: true })} value={model.modelName || ""} />
        </div >
      </div>
    </>
  }

  saveEnableVictimOption = (checked) => {
    this.props._updateOptions("enableVictim", checked, 'value');
  }

  render() {
    const { verificationId, Config } = this.props;
    const { enableVictim } = Config;
    const { searchStatus, logs, logVisible, logPcbName, ibisList, spiceList, modelVisible, victimICComp } = this.state;
    const content = (
      <Panel
        title="Aggressor-Victim Analyzer"
        zIndex={2000}
        onCancel={() => this.closeModal()}
        width={800}
        draggable
        minHeight={200}
      >
        <div className='sierra-victim-aggressor-search'>
          <div className="sierra-victim-aggressor-search-switch">
            <span>Enable Victim Analysis</span>
            <Switch
              size="small"
              className="aurora-switch-small"
              value={enableVictim}
              onChange={(checked) => this.saveEnableVictimOption(checked)}
            />
          </div>
          {enableVictim ? <>
            {/* <Divider className='aurora-divider-horizontal-margin-10-0' /> */}
            {/* {searchStatus !== SUCCESS ? this.searchRender() : this.searchResultRender()} */}
            {this.searchRender()}
            {searchStatus === SUCCESS ? <>
              <Divider className='aurora-divider-horizontal-margin-10-0' />
              {this.searchResultRender()}
            </> : null}
            {logVisible ? <MsgDialogPanel
              title={`Search Log —— ${logPcbName}`}
              className="sierra-victim-aggressor-search-log-panel"
              allowDownload={true}
              showSearch={true}
              fileName={`${logPcbName}-identification.log`}
              messageList={logs}
              closePanel={() => this.setState({ logVisible: false, logs: [] })}
              getSearchLog={getFilterIdentificationLog}
            /> : null}
            {modelVisible ? <ICModelPanel
              record={victimICComp.pinModelsInfo || {}}
              verificationId={verificationId}
              title="Victim - Buffer Model"
              compModel={victimICComp.model || {}}
              product={SIERRA}
              pins={victimICComp.pins || []}
              displayType="model"
              ibisList={ibisList}
              spiceList={spiceList}
              getIbisModelList={getIbisModelList}
              getSpiceModelList={getSpiceModelList}
              getPins={getPins}
              assignModel={this.assignModel}
              notSaveModel={true}
              applyTooltip={{ type: "", msg: "The model will be applied to all victim component pins." }}
            /> : null}
          </> : null}
        </div>
      </Panel>)
    return createPortal(content, this.dialogRoot)
  }
}

const mapState = (state) => {
  const { SierraReducer: { sierra, library: { libraryTreeInfo }, project: { verificationId, currentProjectVerifications = [], selectedKeys } } } = state;
  const { sierraInfo = {} } = sierra;
  const { info = {} } = sierraInfo;
  const currentPCBs = (sierraInfo.Interfaces || []).map(item => ({ pcbId: item.pcbId, pcbName: item.pcb, isPreLayout: designConstructor.isPreLayout(item.pcbId) }));
  const currentInterface = currentProjectVerifications.find(it => it.id === verificationId) || {};
  return {
    Config: sierra.currentConfig,
    signalNames: (info.signals || []).map(it => it.name),
    verificationId,
    interfaceName: currentInterface.name,
    interfaceType: currentInterface.type,
    libraryTreeInfo,
    currentPCBs,
    selectedDesignIDs: getSelectedDesignIDs(selectedKeys),
    Interfaces: sierraInfo.Interfaces || [],
  };
}


const mapDispatch = (dispatch) => ({
  _updateOptions(type, value, update, fixTimeStep) {
    dispatch(updateOptions(type, value, update, fixTimeStep));
  },
  _saveVictimContent(interfaceIdentificationInfo, verificationId, bufferModelParams) {
    dispatch(saveVictimContent(interfaceIdentificationInfo, verificationId, bufferModelParams))
  },
  _selectLayer(layers, designID) {
    dispatch(selectLayer(layers, designID))
  },
  _changeShowNameStatus(status, designID) {
    dispatch(changeShowNameStatus(status, designID))
  },
  _selectChange(obj = {}, designID) {
    dispatch(selectChange(obj, designID))
  },
  changeDisplaySelected(show, designID) {
    dispatch(changeDisplaySelected(show, designID))
  },
})

export default connect(mapState, mapDispatch)(VictimAggressorSearch)
